import { PARTICLES, REDUCED } from "./fx";

const Corner = ({ pos }) => <div className={`hl-corner hl-corner-${pos}`} />;

// Escena "Abriendo el sobre": piso, anillos, mazo, escáner y partículas.
export function Scene() {
  return (
    <div className="hl-scene" aria-hidden>
      {!REDUCED && <div className="hl-floor-wrap"><div data-fx="floor" className="hl-floor" /></div>}
      {!REDUCED && Array.from({ length: PARTICLES }, (_, i) => (
        <div key={i} data-fx="p" className="hl-particle" style={{ left: `${(i * 37 + 11) % 96 + 2}%`, opacity: 0 }} />
      ))}
      <div className="hl-stage">
        <div className="hl-rings">
          <svg data-fx="ring" viewBox="0 0 320 320" className="hl-ring">
            <circle cx="160" cy="160" r="152" fill="none" stroke="rgba(255,255,255,.14)" strokeWidth="1" />
            <circle cx="160" cy="160" r="152" fill="none" stroke="#FF4438" strokeWidth="2" strokeDasharray="120 840" strokeLinecap="round" />
            <circle cx="160" cy="160" r="142" fill="none" stroke="rgba(255,255,255,.28)" strokeWidth="6" strokeDasharray="1 10" />
          </svg>
          <svg data-fx="ring2" viewBox="0 0 320 320" className="hl-ring">
            <circle cx="160" cy="160" r="128" fill="none" stroke="rgba(255,68,56,.5)" strokeWidth="1" strokeDasharray="4 14" />
            <circle cx="160" cy="32" r="4" fill="#FF4438" />
          </svg>
        </div>
        <div className="hl-deck">
          <div data-fx="back1" className="hl-card hl-back1" />
          <div data-fx="back2" className="hl-card hl-back2" />
          <div data-fx="front" className="hl-card hl-front">
            <div className="hl-frame" />
            <img src="/hit-isotipo.png" alt="" className="hl-iso" />
            {!REDUCED && <div data-fx="sheen" className="hl-sheen" />}
            <div data-fx="scan" className="hl-scan" />
          </div>
          <Corner pos="tl" /><Corner pos="tr" /><Corner pos="bl" /><Corner pos="br" />
          <div className="hl-mono hl-scanlabel">SCAN · <span data-fx="hex">0x4A1F</span></div>
        </div>
      </div>
    </div>
  );
}
